import { Component, inject } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true
})
export class AlertComponent {
  alertService = inject(AlertService);

  getAlertClass(type: string): string {
    return `alert-${type}`;
  }
}
